import {isMdUp, screenWidth} from './utils/responsive';

$(function() {
    $("h3").each(function(index) {
        let heading = $(this);

        heading.nextUntil("h3").wrapAll("<div class='collapse' id='collapse-" + index + "'></div>");

        heading.wrap("<a href='' data-toggle='collapse' data-target='collapse-" + index + "' aria-expanded='false'></a>");
        heading.append('<i class="fas fa-angle-down"></i>');

        $("#collapse-"+index+",a[data-target='collapse-"+index+"']").wrapAll("<div class='faq-item card'></div>");
    });

    doLayout();

    $(".page-content").css("opacity", "1");

    $(document).on("click", "a[data-toggle='collapse']", function() {
        $(this).next().collapse('toggle');

        let icon = $(this).find(".fas");

        if(icon.hasClass("fa-angle-down")) {
            icon.removeClass("fa-angle-down").addClass("fa-angle-up");
        } else {
            icon.removeClass("fa-angle-up").addClass("fa-angle-down");
        }
    })
});

var resizeId;
window.addEventListener('resize', function () {
    clearTimeout(resizeId);
    resizeId = setTimeout(doneResizing, 200);
});

function doneResizing() {
    doLayout();
}

function doLayout() {
    let screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if(screenWidth >= 768) {

        $(".faq-wrap").find(".col-md-6").contents().unwrap();

        let faqs = $(".faq-item");

        let half = Math.ceil(faqs.length / 2);

        for(let i = 0; i < faqs.length; i+=half) {
            faqs.slice(i, i+half).wrapAll("<div class='col-md-6'></div>");
        }
    }
}